import React, { ReactElement } from 'react'

type BasketEmptyProps = {
  content: string;
}

const BasketEmpty = ({ content }: BasketEmptyProps): ReactElement => (
  <div dangerouslySetInnerHTML={ { __html: content } }></div>
)

export default BasketEmpty
